
















































































import Vue from 'vue'

export default Vue.extend({
  name: 'App',
  data() {
    return {
      lightMode: false,
      icons: [
        {
          name: 'fa fa-facebook',
          link: 'https://www.facebook.com/profile.php?id=100006454686275',
        },
        {
          name: 'fa fa-twitter',
          link: 'https://twitter.com/gabriel_wzh',
        },
        {
          name: 'fa fa-linkedin',
          link:
            'https://www.linkedin.com/in/%E8%87%AA%E5%8D%8E-%E5%90%B4-81864a115/',
        },
        {
          name: 'fa fa-github',
          link: 'https://github.com/lucifer1004',
        },
      ],
    }
  },
  computed: {
    buttonColor(): string {
      return this.lightMode ? 'green lighten-4' : 'green darken-4'
    },
  },
  watch: {
    lightMode() {
      this.$vuetify.theme.dark = !this.lightMode
    },
  },
})
